export const ShortenIcon = (props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="none" {...props}>
      <path
        stroke="#534F63"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.667"
        d="M8.879 1.5v15M16.758 9h-5.122m0 0 3.152 3.333M11.636 9l3.152-3.333M1 9h5.121m0 0L2.97 12.333M6.12 9 2.97 5.667"
      />
    </svg>
  )
}
